/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overflow_ReductionInputs */

const en_us2_overflow_reduction = /** @type {(inputs: Overflow_ReductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overflow Reduction`)
};

const en_gb2_overflow_reduction = /** @type {(inputs: Overflow_ReductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill Reduction`)
};

/**
* | output |
* | --- |
* | "Overflow Reduction" |
*
* @param {Overflow_ReductionInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const overflow_reduction = /** @type {((inputs?: Overflow_ReductionInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overflow_ReductionInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_overflow_reduction(inputs)
	return en_us2_overflow_reduction(inputs)
});